import React from "react";
import {
  Box,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";

import PageNotFound from "@components/PageNotFound/PageNotFound";
import { CactusIcon } from "@components/Icons";

import { formatCNPJOrCPF } from "@utils/cnpj";
import { capitalizeWords } from "@utils/index";

interface CNPJItem {
  CNPJ: string;
  companyName: string;
}

interface CNPJTableProps {
  items: CNPJItem[];
  onRemove: (index: number) => void;
  isEmpty: boolean;
  isLoading: boolean;
  isCarrierProfile: boolean;
}

export const CNPJTable: React.FC<CNPJTableProps> = ({
  items,
  onRemove,
  isEmpty,
  isLoading,
  isCarrierProfile,
}) => (
  <Grid container sx={{ mt: 2 }}>
    <Grid item xs={12} sx={{ border: "1px solid #72655133", borderRadius: 1 }}>
      <Table
        sx={{
          "& .MuiTableCell-root": {
            fontSize: "1.4rem",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell align="center">CNPJ ou CPF</TableCell>
            <TableCell align="center">Razão Social</TableCell>
            <TableCell align="center">Ações</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, idx) => (
            <TableRow key={item.CNPJ}>
              <TableCell align="center">{formatCNPJOrCPF(item.CNPJ)}</TableCell>
              <TableCell align="center">
                {capitalizeWords(item.companyName)}
              </TableCell>
              <TableCell>
                <Grid container justifyContent="center">
                  <IconButton onClick={() => onRemove(idx)}>
                    <Tooltip title="Remover">
                      <DeleteForeverOutlinedIcon />
                    </Tooltip>
                  </IconButton>
                </Grid>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isEmpty && (
        <Box p={2}>
          <PageNotFound
            title={
              isLoading ? "Pesquisando..." : "Não há CPF ou CNPJ adicionados"
            }
            subtitle={
              isCarrierProfile
                ? "Informe o BP da Transportadora para preenchimento automático dos CNPJs"
                : "Informe um CPF ou CNPJ para incluir no cadastro"
            }
            icon={<CactusIcon />}
          />
        </Box>
      )}
    </Grid>
  </Grid>
);
